import { FEATURE_FLAG } from '~/constants';

import { type RouteExportParams } from '~/types/router.type';

import {
  deliveryRecentChangesSearchDefaults,
  zodDeliveryRecentChangesSearchSchema,
} from './-searchParams';

export const routeParams: RouteExportParams = {
  permissions: ['dln_in.'],
  featureFlag: FEATURE_FLAG.DLN_LIST_V2,
};

export const validateSearch = zodDeliveryRecentChangesSearchSchema;
export const searchDefaults = deliveryRecentChangesSearchDefaults;
